import { render, staticRenderFns } from "./UserDetails_AuthorStat.vue?vue&type=template&id=071f34a1&"
import script from "./UserDetails_AuthorStat.vue?vue&type=script&lang=js&"
export * from "./UserDetails_AuthorStat.vue?vue&type=script&lang=js&"
import style0 from "./UserDetails_AuthorStat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports